// src/components/ScheduleImportCard.jsx
// 授業スケジュールの画面の「名簿を読み込む・受講者を追加」【2026-10-20】
//
//   授業管理（授業一覧）の「名簿から一気に作る」と同じ読み込み欄を置く。
//   ・manaba の履修者名簿 … ManabaRosterImport（授業管理と同じく classId は渡さない。
//     コースごとに行き先＝既存の授業／新しく作る／取り込まない を選ぶ）
//   ・教務システムの受講者一覧 … 中身を見て KyomuRosterImport に振り分け（授業管理と同じ）
//   ・1人ずつ手で追加 … ManualEnrollForm（開いている授業。すべての授業のときは授業を選ぶ）
//   ファイルは画面のどこに落としてもよい（親の ClassDetailPage が受けて incomingFile で渡す）。
import React, { useState } from 'react';
import ManabaRosterImport from './ManabaRosterImport';
import KyomuRosterImport from './KyomuRosterImport';
import ManualEnrollForm from './ManualEnrollForm';

const OPEN_KEY = 'scheduleImportOpen';

export default function ScheduleImportCard({ classId = null, classes = [], auth, token, setErr, setMsg, onChanged,
                                             incomingFile = null, onIncomingTaken }) {
  const [incomingKyomu, setIncomingKyomu] = useState(null);
  // 教務システムの一覧ではなかったファイルを manaba 側へ戻す（授業管理と同じ）
  const [backToManaba, setBackToManaba]   = useState(null);
  const [openState, setOpenState] = useState(() => {
    try { return localStorage.getItem(OPEN_KEY) !== '0'; } catch (e) { return true; }
  });
  const setOpen = (v) => {
    setOpenState(v);
    try { localStorage.setItem(OPEN_KEY, v ? '1' : '0'); } catch (e) { /* 覚えられなくても動く */ }
  };
  // ファイルを落としたときは閉じていても開く
  const open = openState || !!incomingFile || !!incomingKyomu || !!backToManaba;

  return (
    <div className="card" style={{ borderTop: '4px solid #2563eb' }}>
      <div className="card-header" style={{ display: 'flex', alignItems: 'center', gap: '0.8rem', flexWrap: 'wrap',
                                            ...(open ? {} : { borderBottom: 'none', marginBottom: 0, paddingBottom: 0 }) }}>
        <h2 style={{ margin: 0 }}>名簿を読み込む・受講者を追加</h2>
        {!open && (
          <span style={{ fontSize: '0.8rem', color: '#6b7280' }}>manaba・教務システムの名簿の読み込み／1人ずつ手で追加</span>
        )}
        <button type="button" className="btn-secondary" aria-expanded={open}
                style={{ marginLeft: 'auto', padding: '0.2rem 0.7rem', fontSize: '0.85rem' }}
                onClick={() => setOpen(!open)}>
          {open ? '▲ 閉じる' : '▼ 開く'}
        </button>
      </div>

      {/* 閉じても読み込みの途中の状態を失わないように、隠すだけにする */}
      <div style={{ display: open ? 'block' : 'none' }}>
        {/* 授業管理と同じ読み込み欄 */}
        <ManabaRosterImport
          classes={classes}
          token={token}
          setErr={setErr}
          setMsg={setMsg}
          onImported={onChanged}
          incomingFile={backToManaba || incomingFile}
          onIncomingTaken={() => { setBackToManaba(null); if (onIncomingTaken) onIncomingTaken(); }}
          onKyomuDetected={(f) => setIncomingKyomu(f)}
        />
        {/* 教務システムの受講者一覧だったときだけ出る */}
        <KyomuRosterImport embedded
                           onDone={onChanged}
                           incomingFile={incomingKyomu}
                           onIncomingTaken={() => setIncomingKyomu(null)}
                           onNotKyomu={(f) => { setIncomingKyomu(null); setBackToManaba(f); }} />

        <div style={{ display: 'flex', alignItems: 'center', gap: '0.7rem', margin: '1rem 0 0.8rem' }}>
          <span style={{ flex: 1, height: 1, background: '#e5e7eb' }} />
          <span style={{ fontSize: '0.8rem', color: '#9ca3af' }}>または 1人ずつ手で追加</span>
          <span style={{ flex: 1, height: 1, background: '#e5e7eb' }} />
        </div>
        <ManualEnrollForm classId={classId} classes={classes} auth={auth}
                          setErr={setErr} setMsg={setMsg} onAdded={onChanged} />
      </div>
    </div>
  );
}
